import { Fragment, type CSSProperties, type FC } from 'react';

import { useProductBundle } from '../../../../context/ProductBundle/ProductBundle.context';
import type { IProduct } from '../../../../context/ProductBundle/productBundle.interfaces';
import { OutlineBundleProduct } from './OutlineBundleProduct/OutlineBundleProduct';
import OutlineBundleProductSkel from './OutlineBundleProduct/OutlineBundleProductSkel';

import styles from './outlineBundleBody.module.scss';

export const OutlineBundleBody: FC = () => {
  const {
    productList,
    state: { isFetching },
    skeletons,
  } = useProductBundle();

  const fakeProductList: Array<Pick<IProduct, 'articleId'>> = [
    { articleId: 0 },
    { articleId: 1 },
    { articleId: 2 },
  ].slice(0, skeletons);

  return (
    <div
      className={styles.wrapper}
      style={
        {
          '--outlineBundleProductHeight':
            skeletons > 2
              ? '220px' // height of the product when there are 3 products (expected modelIds) under desktop resolution
              : '168px', // height of the product when there are 2 products (expected modelIds) under desktop resolution
        } as CSSProperties
      }
    >
      {isFetching
        ? fakeProductList.map((fakeProduct, index) => (
            <Fragment
              key={`outline-bundle-product-skel-${fakeProduct.articleId}`}
            >
              <OutlineBundleProductSkel
                withCheckbox={index !== 0 && fakeProductList.length > 2}
              />
            </Fragment>
          ))
        : productList.map((product, index) => (
            <OutlineBundleProduct
              index={index}
              key={`outline-bundle-complementary-product-${product.modelId}`}
              product={product}
              withCheckbox={index !== 0 && productList.length > 2}
            />
          ))}
    </div>
  );
};

OutlineBundleBody.displayName = 'OutlineBundleBody';
